export default "__VITE_ASSET__C3EO84wB__"